import apiUrl from '../config/apiUrl';
import { EnterAddressModel } from '../models/request/EnterAddress.model';
import { KycUserInfoModel } from '../models/request/KycUserInfo.model';
import fetchUrl from '../utils/fetchUrl';

export const GET_USER_KYC = async () => {
  return await fetchUrl({
    method: 'GET',
    url: `${apiUrl}kyc/getuserKyc`,
  });
};
export const GET_KYC_LANDING = async () => {
  return await fetchUrl({
    method: 'GET',
    url: `${apiUrl}kyc/kycLanding`,
  });
};
export const START_LEVEL_3 = async () => {
  return await fetchUrl({
    method: 'POST',
    body: {},
    url: `${apiUrl}kyc/startLevel3`,
  });
};
export const CONFIRM_STATEMENT = async () => {
  return await fetchUrl({
    method: 'GET',
    url: `${apiUrl}kyc/confirmStatement`,
  });
};
export const ENTER_ADDRESS = async (data: EnterAddressModel) => {
  return await fetchUrl({
    method: 'POST',
    body: data,
    url: `${apiUrl}kyc/enterAddress`,
  });
};
export const NID_WITH_MOBILE_OTP_CHECK = async (data: { otp: string }) => {
  return await fetchUrl({
    method: 'POST',
    url: `${apiUrl}kyc/nidWithMobileOtpCheck`,
    body: {
      otp: data.otp,
    },
  });
};
export const RESEND_KYC_OTP = async () => {
  return await fetchUrl({
    method: 'POST',
    body: {},
    url: `${apiUrl}kyc/resendKycOtp`,
  });
};
export const CHECK_USER_INFO = async () => {
  return await fetchUrl({
    method: 'GET',
    url: `${apiUrl}kyc/checkUserInfo`,
    body: {},
  });
};
export const USER_INFO_CONFIRMED = async (data: KycUserInfoModel) => {
  const response = fetchUrl({
    method: 'POST',
    url: `${apiUrl}kyc/userInfoConfirmed`,
    body: data,
  });
  return response;
};
export const ENTER_PHONE_NUMBER = async (phoneNumber: string) => {
  const response = fetchUrl({
    method: 'POST',
    body: {},
    url: `${apiUrl}kyc/enterPhoneNumber?phoneNumber=${phoneNumber}`,
  });
  return response;
};
export const CHECK_PHONE_NUMBER = async (confirmCode: string) => {
  const response = fetchUrl({
    method: 'POST',
    body: {},
    url: `${apiUrl}kyc/checkPhoneNumber?otp=${confirmCode}`,
  });
  return response;
};
export const RECALL_PHONE_NUMBER = async () => {
  const response = fetchUrl({
    method: 'POST',
    body: {},
    url: `${apiUrl}kyc/reCallPhoneNumber`,
  });
  return response;
};
